// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { PageFragmentDoc } from '../../graphql/api/cms/page.fragment.generated';
import { PostCategoriesFragmentDoc } from '../../graphql/api/cms/blog/fragments/postCategories.generated';
import { BlogPostPreviewFragmentDoc } from '../../components/cms/component/blog/BlogPostPreview.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const BlogDocument = gql`
    query blog($path: String!, $page: Int!, $limit: Int!, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!) {
  pageByPath(path: $path, locale: $locale) {
    ...page
  }
  ...postCategories
  posts(pagination: {page: $page, limit: $limit}, filter: {locale: $locale}) {
    ...blogPostPreview
  }
  postsAggregation(filter: {locale: $locale}) {
    count
  }
}
    ${PageFragmentDoc}
${PostCategoriesFragmentDoc}
${BlogPostPreviewFragmentDoc}`;

export function useBlogQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.BlogQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.BlogQuery, SchemaTypes.BlogQueryVariables | undefined>({ query: BlogDocument, variables: undefined, ...options });
};